import { DEAD_ZONE_INSPECTOR_PAGE, SPECTRUM_PAGE } from '@/common/constants/pages';
import { KEY_DEADZONES_PENDING_TASKS, KEY_SPECTRUM_PENDING_TASKS } from '@/common/services/Storage';

export const PENDING_TASK_PAGE_MAP: Record<string, string> = {
  [KEY_DEADZONES_PENDING_TASKS]: DEAD_ZONE_INSPECTOR_PAGE,
  [KEY_SPECTRUM_PENDING_TASKS]: SPECTRUM_PAGE,
};
